import {inject, Injectable} from "@angular/core";
import {RssiApiClient} from "src/app/domain/samples/rssi/rssi.api-client";

@Injectable({
  providedIn: 'root'
})
export class RssiService {

  private rssiApiClient = inject(RssiApiClient);

  locations(farmId: string, from: Date, to: Date) {
    return this.rssiApiClient.locations(farmId, from, to);
  }

  latestBatteryVoltages(deviceIds: string[]) {
    return this.rssiApiClient.latestBatteryVoltages(deviceIds);
  }

  batteryVoltages(deviceIds: string[], from: Date, to: Date) {
    return this.rssiApiClient.batteryVoltages(deviceIds, from, to);
  }
}
